<template>
  <v-layout align-center justify-center row fill-height>
    <v-flex xs12 sm8>
      <v-card>
        <v-card-title>
          <v-layout row wrap>
            <v-flex xs12>
              <div class="logo">Pragma</div>
            </v-flex>
            <v-flex xs12>
              <h2>ログイン</h2>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-card-text>
          <v-form id="login-form">
            <v-text-field type="text" label="Email" v-model="email" autocomplete="username" />
            <v-text-field
              type="password"
              label="Password"
              v-model="password"
              autocomplete="current-password"
            />
            {{errorMessage}}
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn @click="signIn">ログイン</v-btn>
        </v-card-actions>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import auth from "@/components/fireAuthInit";
import { mapActions, mapState } from "vuex";
export default {
  data() {
    return {
      email: "",
      password: ""
    };
  },
  created: function() {},
  mounted() {},
  methods: {
    async signIn() {
      this.changeLoadingState(true);
      try {
        await this.logIn({ email: this.email, password: this.password });
      } catch (e) {
        console.error(e)
      } finally {
        this.changeLoadingState(false);
      }
    },
    ...mapActions("auth", ["logIn"]),
    ...mapActions("app", ["changeLoadingState"])
  },
  computed: {
    ...mapState("auth", ["errorMessage"])
  }
};
</script>
<style lang="css" scoped>
div.logo {
  font-size: 20px;
  color: #ff5722;
  font-family: YuGothicM, Roboto, sans-serif;
  font-weight: bold;
}
</style>

